module.exports = __webpack_public_path__ + "static/media/screenshot_4.d7d11bba.png";